import React from "react";
import { usePagination, DOTS } from "./usePagination";

function Pagination({
  totalPost,
  postsPerPage,
  setCurrentPage,
  currentPage,
  siblingCount = 1,
}) {
  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  let pages = [];

  for (let i = 1; i <= Math.ceil(totalPost / postsPerPage); i++) {
    pages.push(i);
  }
  const paginationRange = usePagination({
    totalCount: totalPost,
    pageSize: postsPerPage,
    siblingCount,
    currentPage,
  });

  // If there are less than 2 times in pagination range we shall not render the component
  if (currentPage === 0 || paginationRange?.length < 2) {
    return null;
  }

  return (
    <div className="pagination">
      {/* <p>Showing 1 - {currentPosts.length} of {postData.length}</p> */}
      <p>
        Showing {firstPostIndex + 1} -{" "}
        {totalPost < lastPostIndex ? totalPost : lastPostIndex} of{" "}
        {totalPost}
      </p>
      <div className="pagenation_line"></div>
      <ul>
        <li
          className={currentPage === 1 ? "inactive" : ""}
          onClick={() =>
            currentPage >= 2 && setCurrentPage(currentPage - 1)
          }
        >
          <a>
            <i className="fa fa-angle-left"></i>
          </a>
        </li>

        {paginationRange?.map((page, index) => {
          if (page === DOTS) {
            return (
              <li key={index} className="pagination-item dots">
                &#8230;
              </li>
            );
          }
          return (
            <li
              key={index}
              onClick={() => setCurrentPage(page)}
              className={page === currentPage ? "current" : ""}
            >
              <a>{page}</a>
            </li>
          );
        })}
        <li
          onClick={() =>
            currentPage <= pages.length - 1 &&
            setCurrentPage(currentPage + 1)
          }
          className={currentPage === pages.length ? "inactive" : ""}
        >
          <a>
            <i className="fa fa-angle-right"></i>
          </a>
        </li>
      </ul>
    </div>
  );
}

export default Pagination;
